<template>
  <div>
    <div
      class="solution_menu flex"
      v-show="visible"
      @mouseover="mouseOver"
      @mouseleave="mouseLeave"
    >
      <div class="menu_left">
        <h1>产品&解决方案</h1>
      </div>
      <div class="menu_right menu_right1">
        <h4>解决方案</h4>
        <i></i>
        <ul class="list">
          <li class="hand" v-for="(item, index) in menuData" :key="index">
            <p @click="currentPath(1, index)">{{ item.title }}</p>
          </li>
        </ul>
      </div>
      <div class="menu_right">
        <h4>产业数字化平台</h4>
        <i class="right_s"></i>
        <ul class="list">
          <li class="hand" v-for="(item, index) in menuData2" :key="index">
            <p @click="currentPath(2, index)">{{ item.title }}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      menuData: [
        {
          title: "银链通场景解构平台解决方案",
        },
        {
          title: "数字监管平台管理系统解决方案",
        },
        {
          title: "供应链验真确权平台解决方案",
        },
        {
          title: "风险预警系统解决方案",
        },
      ],
      menuData2: [
        {
          title: "文旅场景供应链服务平台",
        },
        {
          title: "差旅场景供应链服务平台",
        },
        {
          title: "稀土产业数字供应链平台",
        },
        {
          title: "产业数字供应链金融科技平台",
        },
        {
          title: "稀土可再生资源交易服务平台",
        },
        {
          title: "易派客（中石化）供应链场景产融服务专区",
        },
        {
          title: "冻品供应链服务平台",
        },
      ],
    };
  },
  created() {},
  watch: {},
  methods: {
    currentPath(val, idx) {
      if (val == 1) {
        this.$router.push({
          path: "/solution",
          query: {
            scene: idx + 1,
          },
        });
      } else {
        this.$router.push({
          path: "/product",
          query: {
            product: idx + 1,
          },
        });
      }
    },
    // 移入
    mouseOver() {
      this.$emit("changeMover", true);
    },
    // 移出
    mouseLeave() {
      this.$emit("changeMover", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.solution_menu {
  height: 406px;
  width: 100%;
  background-color: #ffffff;
  position: absolute;
  top: 80px;
  left: 0;
  z-index: 999999;

  .menu_left {
    height: 406px;
    width: 424px;
    margin-right: 148px;
    background: url("/static/images/solution/menu.png") no-repeat;
    background-size: 100% 100%;

    h1 {
      font-weight: 500;
      font-size: 24px;
      min-width: 210px;
      color: #333333;
      margin: 55px 128px 0 88px;
    }
  }

  .menu_right {
    text-align: left;
    margin-top: 60px;

    h4 {
      font-weight: 600;
      font-size: 20px;
      color: #333333;
    }

    i {
      display: block;
      width: 225px;
      height: 0px;
      border: 1px solid #e8e8e8;
      margin: 20px 0;
    }
    .right_s {
      width: 635px;
    }
    ul {
      position: relative;
      li {
        margin: 30px 0;

        p {
          font-weight: 400;
          font-size: 14px;
          color: #454343;
        }
        p:hover {
          color: #ff6633;
        }
      }

      li:hover {
        color: #333333;
      }

      li:nth-child(5) {
        position: absolute;
        top: -30px;
        left: 295px;
      }

      li:nth-child(6) {
        position: absolute;
        top: 18px;
        left: 295px;
      }

      li:nth-child(7) {
        position: absolute;
        top: 64px;
        left: 295px;
      }
    }
  }
  .menu_right1 {
    margin-right: 110px;
    min-width: 255px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SolutionMenu.vue